import { Icon, Menu } from 'semantic-ui-react';
import { getPath, roles, userAllowed, NetworkType, isAllLocations, NHN_PWN_disabled, NDAC_NHN_pages_disabled } from '../../helpers/utils';
import LocationsNav from '../LocationsNav';
import React, { useState, useMemo } from 'react';
import { useSelector } from 'react-redux';
import { SubNavLink } from './PageSubNav';
import dashboard from '../../semantic-ui/site/assets/icons/nav/dashboard.svg';
import reporting from '../../semantic-ui/site/assets/icons/nav/reporting.svg';
import simManagement from '../../semantic-ui/site/assets/icons/nav/sim-management.svg';
import devices from '../../semantic-ui/site/assets/icons/nav/devices.svg';
import inventory from '../../semantic-ui/site/assets/icons/nav/inventory.svg';
import performance from '../../semantic-ui/site/assets/icons/nav/performance.svg';
import alert from '../../semantic-ui/site/assets/icons/nav/security-alert.svg';
import ticket from '../../semantic-ui/site/assets/icons/nav/ticket.svg';
import userManagement from '../../semantic-ui/site/assets/icons/nav/user-management.svg';
import user from '../../semantic-ui/site/assets/icons/nav/user.svg';
import { SOLUTION_TYPE } from '../../helpers/const';
import { useSimPageSavedTabNavigationRedirect } from '../sims/utils/useSimPageSavedTabNavigationRedirect';
import { isPerformanceManageAllowed, isPerformanceManageAllowedSA } from '../../helpers/dashboardUtil';

export const LeftNav = (props) => {
    const { userRoles, enterpriseId, isIBC, isPMEC, onClick } = props;
    const [isYourNetworkExpanded, setIsYourNetworkExpanded] = useState(true); // State for expansion
    const [isAccessAndPermissionExpanded, setIsAccessAndPermissionExpanded] = useState(true);
    const [isSupportExpanded, setIsSupportExpanded] = useState(true);
    const [isYourPmecExpanded, setIsYourPmecExpanded] = useState(true);
    const { solutionType, isMultiNibSim } = useSelector((state) => state.auth);
    const isEP5G = useMemo(() => solutionType === SOLUTION_TYPE.EP5G, [solutionType]);
    const { getSavedSimsTabPath } = useSimPageSavedTabNavigationRedirect();
    const viewPerformancePage = userAllowed(userRoles, [roles.VIEW_PERFORMANCE_PAGE, roles.VIEW_NEW_PERFORMANCE_PAGE]);

    const isAllLocationsSelected = isAllLocations();
    const isOverviewAllowedSA = userAllowed(
        userRoles,
        [
            roles.MANAGE_5GSA_REGISTERED_DEVICES,
            roles.MANAGE_4G_RAN_UL_THROUGHPUT,
            roles.MANAGE_4G_RAN_DL_THROUGHPUT,
            roles.MANAGE_5G_RAN_UL_THROUGHPUT,
            roles.MANAGE_5G_RAN_DL_THROUGHPUT,
            roles.MANAGE_4G_CORE_UL_THROUGHPUT,
            roles.MANAGE_4G_CORE_DL_THROUGHPUT,
            roles.MANAGE_5G_CORE_UL_THROUGHPUT,
            roles.MANAGE_5G_CORE_DL_THROUGHPUT,
            roles.MANAGE_4G5G_RAN_UL_THROUGHPUT,
            roles.MANAGE_4G5G_RAN_DL_THROUGHPUT,
            roles.KPI_4GRAN_DATA_ACCESSIBILITY,
            roles.KPI_4GRAN_DATA_MOBILITY,
            roles.KPI_4GRAN_DATA_RETAINABILITY,
            roles.VIEW_KPI_5G_NSA_ACCESSIBILITY,
            roles.VIEW_KPI_5G_NSA_RETAINABILITY,
            roles.VIEW_KPI_5G_NSA_MOBILITY,
            roles.VIEW_KPI_VoLTE_ACCESSIBILITY,
            roles.VIEW_KPI_VoLTE_RETAINABILITY,
            roles.VIEW_KPI_VoLTE_MOBILITY
        ],
        true
    );

    // Function to toggle the "Your Network" expansion
    const toggleYourNetwork = () => {
        setIsYourNetworkExpanded(!isYourNetworkExpanded);
    };

    const toggleAccessAndPermission = () => {
        setIsAccessAndPermissionExpanded(!isAccessAndPermissionExpanded);
    };

    const toggleSupport = () => {
        setIsSupportExpanded(!isSupportExpanded);
    };

    const toggleYourPmec = () => {
        setIsYourPmecExpanded(!isYourPmecExpanded);
    };

    return (
        <>
            <Menu key={1} fluid vertical className="subnav no-print" onClick={onClick}>
                {/* <LocationsNav /> part of the old multi-nib */}
                <Menu.Item as={SubNavLink} name="dashboard" to={getPath(enterpriseId, '/')} activeClassName="active" exact>
                    <img src={dashboard} />
                    Dashboard
                </Menu.Item>

                {userAllowed(userRoles, [roles.VIEW_USERS, roles.VIEW_ROLES]) && (
                    <Menu.Item className="tour-step-7" onClick={toggleAccessAndPermission}>
                        <Menu.Header>Access & permissions</Menu.Header>
                    </Menu.Item>
                )}

                {isAccessAndPermissionExpanded && (
                    <>
                        {userAllowed(userRoles, [roles.VIEW_USERS]) && (
                            <Menu.Item
                                as={SubNavLink}
                                name="users"
                                to={getPath(enterpriseId, '/users')}
                                activeClassName="active"
                                exact
                                isActive={(match, location) => {
                                    // Active for /users and /users/:id
                                    return match || /^\/users(\/\d+)?$/.test(location.pathname);
                                }}>
                                <img src={user} />
                                Users
                            </Menu.Item>
                        )}
                        {userAllowed(userRoles, [roles.VIEW_ROLES]) && (
                            <Menu.Item
                                as={SubNavLink}
                                name="roles"
                                to={getPath(enterpriseId, '/users/roles')}
                                activeClassName="active"
                                exact
                                isActive={(match, location) => match || location.pathname.startsWith('/users/roles')}>
                                <img src={userManagement} />
                                Roles
                            </Menu.Item>
                        )}
                    </>
                )}
                {/* "Your Network" root menu with expansion */}
                {/* show only if any children are shown */}
                {((userAllowed(userRoles, [roles.VIEW_SUBSCRIBERS]) && !isIBC) ||
                    (userAllowed(userRoles, [roles.VIEW_ESIM_SUPPORT]) && isEP5G) ||
                    (userAllowed(userRoles, [roles.VIEW_BACKUPS]) && !isIBC) ||
                    userAllowed(userRoles, [roles.VIEW_INVENTORY]) ||
                    (userAllowed(userRoles, [roles.VIEW_DEVICE_MONITORING, roles.MANAGE_DEVICES], false) && !isIBC) ||
                    (userAllowed(userRoles, [roles.VIEW_NETWORK_PERFORMANCE]) &&
                        (!isEP5G ? isPerformanceManageAllowed(userRoles) : isPerformanceManageAllowedSA(userRoles))) ||
                    (userAllowed(userRoles, [roles.VIEW_NETWORK_PERFORMANCE, roles.VIEW_KPI_EXFO], false) &&
                        !isIBC &&
                        (!isEP5G ? isPerformanceManageAllowed(userRoles) : isPerformanceManageAllowedSA(userRoles)))) && (
                    <Menu.Item onClick={toggleYourNetwork}>
                        <Menu.Header>Your network</Menu.Header>
                    </Menu.Item>
                )}

                {/* Menu items under "Your Network" */}
                {isYourNetworkExpanded && (
                    <>
                        {/* if only backups permission then navigate directly to backups tab */}
                        {userAllowed(userRoles, [roles.VIEW_SIM_MANAGEMENT]) &&
                            !NHN_PWN_disabled(solutionType, userRoles) &&
                            !NDAC_NHN_pages_disabled(solutionType) &&
                            ((!isAllLocationsSelected && userAllowed(userRoles, [roles.VIEW_BACKUPS])) ||
                                (userAllowed(userRoles, [roles.VIEW_SUBSCRIBERS]) && (!isAllLocationsSelected || isMultiNibSim))) &&
                            !isIBC && (
                                <Menu.Item className="tour-step-8" as={SubNavLink} name="backup" to={getSavedSimsTabPath()} activeClassName="active">
                                    <img src={simManagement} />
                                    SIM management
                                </Menu.Item>
                            )}
                        {!isAllLocationsSelected && userAllowed(userRoles, [roles.VIEW_INVENTORY]) && (
                            <Menu.Item
                                className="tour-step-9"
                                as={SubNavLink}
                                name="inventory"
                                to={getPath(enterpriseId, '/monitoring/inventory')}
                                activeClassName="active"
                                exact>
                                <img src={inventory} />
                                Network navigator
                            </Menu.Item>
                        )}
                        {isAllLocationsSelected &&
                            userAllowed(userRoles, [roles.MULTI_SITE_INVENTORY, roles.MANAGE_MULTI_NIB_COMBINED_VIEW], false) && (
                                <Menu.Item
                                    as={SubNavLink}
                                    name="inventory"
                                    to={getPath(enterpriseId, '/monitoring/multi-site-inventory')}
                                    activeClassName="active"
                                    exact>
                                    <img src={inventory} />
                                    Network navigator
                                </Menu.Item>
                            )}
                        {isAllLocationsSelected &&
                            userAllowed(userRoles, [roles.MULTI_SITE_PERFORMANCE, roles.MANAGE_MULTI_NIB_COMBINED_VIEW], false) && (
                                <Menu.Item
                                    as={SubNavLink}
                                    name="performance"
                                    to={getPath(enterpriseId, '/monitoring/multi-site-performance')}
                                    activeClassName="active"
                                    exact>
                                    <img src={performance} />
                                    Performance
                                </Menu.Item>
                            )}
                        {userAllowed(userRoles, [roles.VIEW_DEVICE_MONITORING, roles.MANAGE_DEVICES], false) &&
                            !NHN_PWN_disabled(solutionType, userRoles) &&
                            !NDAC_NHN_pages_disabled(solutionType) &&
                            !isIBC && (
                                <Menu.Item
                                    className="tour-step-10"
                                    as={SubNavLink}
                                    name="devices"
                                    to={getPath(enterpriseId, '/monitoring/devices')}
                                    activeClassName="active"
                                    exact>
                                    <img src={devices} />
                                    Devices
                                </Menu.Item>
                            )}
                        {!isAllLocationsSelected &&
                            viewPerformancePage &&
                            userAllowed(userRoles, [roles.VIEW_NETWORK_PERFORMANCE]) &&
                            (!isEP5G ? isPerformanceManageAllowed(userRoles) : isPerformanceManageAllowedSA(userRoles)) && (
                                <Menu.Item
                                    className="tour-step-11"
                                    as={SubNavLink}
                                    name="performance"
                                    to={
                                        !isEP5G || isOverviewAllowedSA
                                            ? getPath(enterpriseId, '/monitoring/performance')
                                            : getPath(enterpriseId, '/monitoring/performance/usage')
                                    }
                                    activeClassName="active">
                                    <img src={performance} />
                                    Performance
                                </Menu.Item>
                            )}
                        {!isAllLocationsSelected &&
                            userAllowed(userRoles, [roles.VIEW_NETWORK_PERFORMANCE, roles.VIEW_KPI_EXFO], false) &&
                            !isIBC &&
                            (!isEP5G ? isPerformanceManageAllowed(userRoles) : isPerformanceManageAllowedSA(userRoles)) && (
                                <Menu.Item
                                    as={SubNavLink}
                                    name="performance"
                                    to={getPath(enterpriseId, '/monitoring/performance-exfo')}
                                    disabled={isAllLocations()}
                                    activeClassName="active">
                                    <img src={performance} />
                                    Performance EXFO
                                </Menu.Item>
                            )}
                        {!isAllLocationsSelected &&
                            userAllowed(userRoles, [roles.MANAGE_FLS_KPI_INTEGRATION]) &&
                            !isIBC &&
                            (!isEP5G ? isPerformanceManageAllowed(userRoles) : isPerformanceManageAllowedSA(userRoles)) && (
                                <Menu.Item
                                    as={SubNavLink}
                                    name="performance"
                                    to={getPath(enterpriseId, '/monitoring/performance-fls')}
                                    disabled={isAllLocations()}
                                    activeClassName="active">
                                    <img src={performance} />
                                    PerformanceFLS
                                </Menu.Item>
                            )}
                    </>
                )}

                {/* "Your MEC" root menu */}
                {!isAllLocationsSelected &&
                    (userAllowed(userRoles, [roles.VIEW_MEC_PERFORMANCE, roles.MANAGE_MEC_PERFORMANCE], false) ||
                        userAllowed(userRoles, [roles.VIEW_MEC_PERFORMANCE, roles.MANAGE_MEC_PERFORMANCE_OSND], false) ||
                        userAllowed(userRoles, [roles.VIEW_MEC_REPORTS, roles.MANAGE_MEC_USAGE_REPORTS], false)) &&
                    !isIBC &&
                    isPMEC && (
                        <Menu.Item onClick={toggleYourPmec}>
                            <Menu.Header>Your MEC</Menu.Header>
                        </Menu.Item>
                    )}
                {/* Menu items under "Your MEC" */}
                {!isAllLocationsSelected && isYourPmecExpanded && (
                    <>
                        {userAllowed(userRoles, [roles.VIEW_MEC_PERFORMANCE, roles.MANAGE_MEC_PERFORMANCE], false) && !isIBC && isPMEC && (
                            <Menu.Item
                                className="tour-step-12"
                                as={SubNavLink}
                                name="performance"
                                to={getPath(enterpriseId, '/mec/performance')}
                                activeClassName="active"
                                disabled={isAllLocations()}>
                                <img src={performance} />
                                Performance
                            </Menu.Item>
                        )}
                        {userAllowed(userRoles, [roles.VIEW_MEC_PERFORMANCE, roles.MANAGE_MEC_PERFORMANCE_OSND], false) && isPMEC && !isIBC && (
                            <Menu.Item
                                as={SubNavLink}
                                name="performance"
                                to={getPath(enterpriseId, '/mec/performance-osnd')}
                                disabled={isAllLocations()}
                                activeClassName="active">
                                <img src={performance} />
                                Performance
                            </Menu.Item>
                        )}
                        {userAllowed(userRoles, [roles.VIEW_MEC_REPORTS, roles.MANAGE_MEC_USAGE_REPORTS], false) && isPMEC && !isIBC && (
                            <Menu.Item
                                className="tour-step-13"
                                as={SubNavLink}
                                name="reporting"
                                to={getPath(enterpriseId, '/mec/usage-reports')}
                                activeClassName="active"
                                disabled={isAllLocations()}>
                                <img src={reporting} />
                                Usage reports
                            </Menu.Item>
                        )}
                    </>
                )}

                {(userAllowed(userRoles, [roles.VIEW_MANAGE_ALERTS, roles.MANAGE_ALERTS], false) ||
                    userAllowed(userRoles, [roles.VIEW_TICKETING])) && (
                    <Menu.Item onClick={toggleSupport}>
                        <Menu.Header>Support</Menu.Header>
                    </Menu.Item>
                )}

                {/* Menu items under "Support" */}
                {isSupportExpanded && (
                    <>
                        {!isAllLocationsSelected &&
                            userAllowed(userRoles, [roles.VIEW_MANAGE_ALERTS, roles.MANAGE_ALERTS], false) &&
                            !NHN_PWN_disabled(solutionType, userRoles) && (
                                <Menu.Item
                                    className="tour-step-14"
                                    as={SubNavLink}
                                    name="alerts"
                                    to={getPath(enterpriseId, '/support/alerts')}
                                    activeClassName="active"
                                    disabled={isAllLocations()}>
                                    <img src={alert} />
                                    Alerts
                                </Menu.Item>
                            )}
                        {userAllowed(userRoles, [roles.VIEW_TICKETING]) && (
                            <Menu.Item
                                className="tour-step-15"
                                as={SubNavLink}
                                name="ticketing"
                                to={getPath(enterpriseId, '/maintenance/ticketing')}
                                activeClassName="active">
                                <img src={ticket} />
                                Ticketing
                            </Menu.Item>
                        )}
                        {!isAllLocationsSelected && userAllowed(userRoles, [roles.VIEW_AUDIT_LOGS]) && (
                            <Menu.Item as={SubNavLink} name="logs" to={getPath(enterpriseId, '/support/logs')} activeClassName="active" exact>
                                <img src={alert} />
                                Logs
                            </Menu.Item>
                        )}
                    </>
                )}


                {false && (
                    <Menu.Item
                        as={SubNavLink}
                        name="applications"
                        to={getPath(enterpriseId, '/monitoring/applications')}
                        activeClassName="active"
                        disabled={isAllLocations()}
                        exact>
                        Applications
                    </Menu.Item>
                )}
                {false && (
                    <Menu.Item
                        as={SubNavLink}
                        name="analytics"
                        to={getPath(enterpriseId, '/monitoring/analytics')}
                        activeClassName="active"
                        exact
                        disabled={isAllLocations()}>
                        Analytics
                    </Menu.Item>
                )}
            </Menu>
        </>
    );
};
